<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="模板名称" name="name"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button power="b_freight_template_add" color="sys" @click="navigateTo('/freight_template_add')">新建运费模板</c-button>
			</m-operate>
			
			<c-table ref="table">
                <c-table-column
                        label="模板ID"
                        name="id"
                        width="70"
                ></c-table-column>

				<c-table-column
					label="模板名称"
					name="name"
					width="200"
				></c-table-column>
				
				<c-table-column
					label="计费方式"
					name="type"
					width="80"
				>
					<template v-slot="{data}">
            <span v-if="data.type == 1" style="color:green">按件计费</span>
            <span v-if="data.type == 2" style="color:dodgerblue">按重计费</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="最后编辑时间"
					name="edit_date"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="是否启用"
					name="state"
					width="80"
				>
					<template v-slot="{data}">
            <span v-if="data.state == 1" style="color:red">禁用</span>
            <span v-if="data.state == 2" style="color:green">启用</span>
					</template>
				</c-table-column>
				
				<c-table-column
					type="button"
					label="操作"
					width="230"
					limit="4"
				>
					<template v-slot="{data}">
						<c-table-button power="b_freight_template_state" v-if="data.state == 1 && data.id != 999998 && data.id != 999999" @click="disabledHandle(data, false)">启用</c-table-button>
						<c-table-button power="b_freight_template_state" v-if="data.state != 1 && data.id != 999998 && data.id != 999999" @click="disabledHandle(data, true)">禁用</c-table-button>
						<c-table-button power="b_freight_template_edit" @click="navigateTo(`/freight_template_edit/${data.id}`)">编辑</c-table-button>
						<c-table-button power="b_freight_template_del" v-if="data.id != 999998 && data.id != 999999"  @click="deleteHandle(data.id)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
	</page>
</template>

<script>
	export default {
		name: 'm_freight_template',
		
		data() {
			return {
			}
		},
		
		mounted() {
			this.$refs.search.search();
			
			this.$bus.$on('freightTemplate.update', page => {
				this.$refs.table.update(page);
			});
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/freight_template/list',
					data
				});
			},
			
			disabledHandle(data, disabled) {
				this.request({
					url: '/freight_template/state',
					data: {
						id: data.id,
						state: disabled ? 1 : 2
					},
					loading: true,
					success: () => {
						data.state = disabled ? 1 : 2;
					}
				});
			},
			
			deleteHandle(id) {
				this.$confirm({
					text: '确定要删除此运费模板吗？',
					resolve: () => {
						this.request({
							url: '/freight_template/remove',
							data: {
								id
							},
							loading: true,
							success: () => {
								this.$refs.table.update();
								this.$bus.$emit('productEdit.updateFreightTmpl');
							}
						});
					}
				});
			}
		}
	}
</script>